'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateProductOnEnter = exports.getActiveProduct = undefined;

var _products = require('./products');

var products = _interopRequireWildcard(_products);

var _Products = require('./Products.reducer');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getActiveProduct = exports.getActiveProduct = function getActiveProduct(state) {
  var _selectActiveProduct = (0, _Products.selectActiveProduct)(state),
      key = _selectActiveProduct.key;

  return products[key];
};

var activateProductOnEnter = exports.activateProductOnEnter = function activateProductOnEnter(store, Product, dataMapper) {
  return function (_ref, replaceState, cb) {
    var params = _ref.params;
    return store.runSagaOnce(Product.activate.bind(Product), dataMapper(params)).done.finally(cb);
  };
};